module.exports = __webpack_public_path__ + "img/360ext.db354d7e.svg";